import React from 'react';

const AboutUs = () => {
    const teamMembers = [
        { name: 'Neel Modi', designation: 'Managing Director', image: '/assets/Neel_Modi.png' },
        { name: 'Vansh Mahajan', designation: 'Chief Executive Officer', image: '/assets/Vansh_Mahajan.png' },
        { name: 'Mukul Dagar', designation: 'Full Stack Developer', image: '/assets/Mukul_Dagar.jpg' },
        { name: 'Vipul Paliwal', designation: 'Full Stack Developer', image: '/assets/Vipul_Paliwal.jpg' },
        { name: 'Tushar Thakur', designation: 'Backend Developer', image: '/assets/Tushar_Thakur.jpg' },
        { name: 'Sain Biswas', designation: 'Backend Developer', image: '/assets/Sain_Biswas.jpg' },
        { name: 'Gautam Kumar', designation: 'Product Designer', image: '/assets/Gautam_Kumar.png' },
        { name: 'Swastik Kumar', designation: 'PCB Designer', image: '/assets/Swastik_Kumar.jpg' },
    ];

    return (
        <div className="bg-gray-50">
            {/* Hero section */}
            <div className="bg-primary mt-[90px] py-16 px-4 sm:px-6 lg:px-8 text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                    About HISAAB
                </h1>
                <p className="mt-6 text-xl text-blue-100 max-w-3xl mx-auto">
                    Revolutionizing Smart Accounting for Businesses
                </p>
            </div>

            {/* Main content */}
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                {/* Mission section */}
                <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
                    <div className='border-2 border-primary rounded-lg p-8 shadow-lg shadow-blue-200'>
                        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                            Our Mission
                        </h2>
                        <p className="mt-3 max-w-3xl text-lg text-gray-500">
                            At HISAAB, we're on a mission to transform how businesses manage their finances. We understand
                            the challenges that small business owners and merchants face with traditional accounting
                            methods—they're time-consuming, error-prone, and often require specialized knowledge.
                        </p>
                        <p className="mt-3 max-w-3xl text-lg text-gray-500">
                            Our team is building an AI-powered smart accounting device that eliminates these pain points.
                            HISAAB makes bookkeeping, payments, and financial insights seamless through intelligent
                            automation and user-friendly features designed specifically for business owners, not accountants.
                        </p>
                    </div>
                    <div className="mt-10 lg:mt-0">
                        <div className="bg-blue-600 rounded-lg shadow-xl overflow-hidden">
                            <div className="px-6 py-8 sm:p-10 bg-white">
                                <h3 className="text-xl font-medium text-gray-900">Our Vision</h3>
                                <div className="mt-4 text-base text-gray-500">
                                    <p>
                                        We envision a world where entrepreneurs can focus on growing their businesses
                                        without being bogged down by financial management complexities. HISAAB aims to
                                        be the trusted financial companion for millions of businesses worldwide, providing
                                        them with the tools they need to thrive in an increasingly competitive marketplace.
                                    </p>
                                </div>
                            </div>
                            <div className="px-6 py-8 sm:p-10 bg-primary">
                                <h3 className="text-xl font-medium text-white">Our Approach</h3>
                                <ul className="mt-6 space-y-4">
                                    <li className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-blue-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <p className="ml-3 text-base text-blue-50">
                                            <span className="font-medium text-white">Intuitive:</span> Designed for business owners of all technical abilities
                                        </p>
                                    </li>
                                    <li className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-blue-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <p className="ml-3 text-base text-blue-50">
                                            <span className="font-medium text-white">Comprehensive:</span> Addressing the full spectrum of financial management needs
                                        </p>
                                    </li>
                                    <li className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-blue-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <p className="ml-3 text-base text-blue-50">
                                            <span className="font-medium text-white">Intelligent:</span> Leveraging AI to provide insights beyond basic calculations
                                        </p>
                                    </li>
                                    <li className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <svg className="h-6 w-6 text-blue-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <p className="ml-3 text-base text-blue-50">
                                            <span className="font-medium text-white">Reliable:</span> Built with security and accuracy as foundational principles
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Team section */}
                <div className="mt-16">
                    <div className="text-center">
                        <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Meet Our Team</h2>
                        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            The People Behind HISAAB
                        </p>
                        <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                            We are a team of 8 passionate innovators, combining expertise in hardware, software, AI, and finance to bring HISAAB to life.
                        </p>
                    </div>

                    <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="bg-white overflow-hidden shadow rounded-lg">
                                <div className="flex items-center">
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="h-16 w-16 rounded-full object-cover ml-4"
                                    />
                                    <div className="px-4 py-5 sm:px-6 grow">
                                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                                            {member.name}
                                        </h3>
                                        <p className="mt-1 max-w-2xl text-sm text-gray-500">
                                            {member.designation}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Journey section */}
                <div className="mt-16">
                    <div className="text-center">
                        <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Our Journey</h2>
                        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            Join Us on This Journey
                        </p>
                    </div>

                    <div className="mt-10 bg-white shadow overflow-hidden rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <div className="text-center">
                                <p className="mt-1 text-lg text-gray-500">
                                    HISAAB is more than just a product—it's a movement to democratize financial intelligence for
                                    businesses of all sizes. We're excited to partner with forward-thinking entrepreneurs who are
                                    ready to transform how they manage their business finances.
                                </p>
                                <div className="mt-8 flex justify-center">
                                    <div className="inline-flex rounded-md shadow">
                                        <a
                                            href="/become-merchant"
                                            className="px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-secondary"
                                        >
                                            Join Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;